import { element } from 'protractor';
import { ActivatedRoute } from '@angular/router';
import { Component, HostListener } from '@angular/core';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';

import * as $ from 'jquery';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})



export class AppComponent {
    fragment = 'section_1';
    constructor(private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any, private route: ActivatedRoute
    ) {
        this.route.fragment.subscribe(fragment => {
            this.fragment = fragment;
        });
    }
    ngOnInit() {
        this.document.body.setAttribute('data-spy', 'scroll');
        this.document.body.setAttribute('data-target', '#navbar');
        this.document.body.setAttribute('data-offset', '50');
        this.pageScrollService.scroll({
            document: this.document,
            scrollTarget: '.theEnd',
        });
    }
}

